import mediator from "@tvg/mediator";

export const setGtmInfoScreenErrorEvent = ({
  eventLabel,
  eventAction = "",
  module
}) =>
  mediator.base.dispatch({
    type: "REGISTRATION:INFO_SCREEN_ERROR",
    payload: {
      eventAction: `${eventAction} Modal Loaded`,
      eventLabel,
      module
    }
  });

export const onClickGtmInfoScreenEvent = ({
  eventAction = "",
  eventLabel,
  module
}) =>
  mediator.base.dispatch({
    type: "REGISTRATION:INFO_SCREEN_CTA_CLICK",
    payload: {
      eventAction: `${eventAction} CTA Clicked`,
      eventLabel,
      module
    }
  });
